import {
  afterNextRender,
  AfterRenderRef,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { ButtonComponent, ButtonLinkComponent, ImageComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { AdvertisingModalContentModel } from '@libs/cms/models';
import { NavItemModel } from '@libs/shared/models';
import { NavLinkDirective } from '@libs/shared/ui';
import { ContentBaseComponent } from '../content-base.component';
import { AdvertisingModalService } from './advertising-modal.service';

@Component({
  selector: 'ui-advertising-modal-content',
  templateUrl: './advertising-modal-content.component.html',
  styleUrls: ['./advertising-modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    AdvertisingModalService,
  ],
  imports: [
    ImageComponent,
    IconComponent,
    MatDialogContent,
    NavLinkDirective,
    MatDialogActions,
    ButtonComponent,
    ButtonLinkComponent,
    MatDialogClose,
  ],
})
export class AdvertisingModalContentComponent extends ContentBaseComponent<AdvertisingModalContentModel> {
  private readonly advertisingModalService: AdvertisingModalService = inject(AdvertisingModalService);

  private readonly tplAdvertisingDialog: Signal<TemplateRef<void>> = viewChild.required('tplAdvertisingDialog');

  private readonly registerModal: AfterRenderRef = afterNextRender((): void => {
    this.advertisingModalService.registerModal(
      this.data(),
      this.tplAdvertisingDialog(),
    );
  });

  public override readonly isContent: boolean = false;

  public readonly imageLink: Signal<NavItemModel | undefined> = computed(() => {
    const data: AdvertisingModalContentModel = this.data();

    return data.image && data.link ? data.link : undefined;
  });
}
